import React, { ReactNode } from 'react';
import { Chit, ChitContent, ChitMain, ChitAvatar, ChitText, ChitArrow } from 'src/components/ui/chit';

interface NavigationChitProps {
  title: string;
  description: string;
  icon: ReactNode;
  onClick: () => void;
}

export const NavigationChit: React.FC<NavigationChitProps> = ({
  title,
  description,
  icon,
  onClick
}) => {
  return (
    <Chit onClick={onClick}>
      <ChitContent>
        <ChitMain>
          <ChitAvatar icon={icon} />
          <ChitText 
            title={title}
            description={description}
          />
        </ChitMain>
        <ChitArrow />
      </ChitContent>
    </Chit>
  );
};